module.exports = __webpack_public_path__ + "img/search-plus.c6ffa803.svg";